'use client';

import { Dialog } from '@base-ui/react/dialog';
import { css } from '@repo/pandacss/css';
import { useElementInteracted } from '@repo/platform-analytics/hooks/useElementInteracted';
import { getOrCreateId } from '@repo/platform-utils/static-ids';
import { CloseIcon } from '@repo/ui/icons/CloseIcon';
import { useRef } from 'react';
import { DialogRoot } from '@/shared/ui/DialogRoot/DialogRoot';
import { useBranchId } from '../../model/Context/hooks';
import { useBranchedPageAction } from '../../model/useBranchedPageAction';
import { ExitModal } from './ExitModal';
import { useExitModalCloseAction } from './ExitModal/useExitModalCloseAction';
export function CloseFlow({
  desktopOnly = false,
  isDarkVariant = false
}: {
  desktopOnly?: boolean;
  isDarkVariant?: boolean;
}) {
  const openActivityIdRef = useRef('');
  const openActivityId = getOrCreateId(openActivityIdRef);
  const branchId = useBranchId();
  const fireClosePageActionAnalyticsEvent = useBranchedPageAction({
    actionName: 'cardfinder_flow_exit',
    actionType: 'select',
    actionInput: 'exit',
    activityId: openActivityId
  });
  const fireCloseElementInteracted = useElementInteracted({
    entityName: 'cardfinder_flow_exit',
    interactionType: 'click',
    itemCopy: 'exit',
    eventId: openActivityId,
    additionalAttributes: branchId ? {
      page_branch_name: branchId
    } : undefined
  });
  const {
    featureViewedActivityId,
    fireCloseAction,
    fireDismissInteraction
  } = useExitModalCloseAction(branchId);
  return <DialogRoot
  // trap-focus: keep focus in the dialog without locking document scroll (avoids scrollbar layout shift).
  modal="trap-focus" onOpenChange={(open, eventDetails) => {
    if (!open) {
      fireCloseAction(eventDetails.reason);
    }
  }}>
      <Dialog.Trigger render={<button type="button" className={css({
      width: '[20px]',
      height: '[20px]',
      lg: {
        position: 'absolute',
        top: '[25px]',
        right: '[25px]',
        width: '[24px]',
        height: '[24px]'
      },
      cursor: 'pointer',
      border: 'none',
      rounded: 'full',
      color: {
        base: 'neutral.darker',
        lg: isDarkVariant ? 'neutral.darker' : 'common.white'
      },
      px: '[0]',
      bg: '[transparent]',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      _hover: {
        bg: {
          base: 'neutral.lightest',
          lg: isDarkVariant ? 'neutral.lightest' : 'greens.dark'
        }
      },
      ...(desktopOnly && {
        display: {
          base: 'none',
          lg: 'flex'
        }
      })
    })} aria-label="Close credit card finder" onClick={() => {
      fireClosePageActionAnalyticsEvent();
      fireCloseElementInteracted();
    }}>
            <CloseIcon fill="currentColor" />
          </button>} />
      <ExitModal featureViewedActivityId={featureViewedActivityId} branchId={branchId} onDismiss={fireDismissInteraction} />
    </DialogRoot>;
}